<div class="product-info-modal-overlay">
  <div class="product-info-modal">
    @if (isLoading()) {
      <div class="loading-overlay">
        <mat-progress-spinner mode="indeterminate" diameter="40" />
      </div>
    }
    <div class="product-info-modal__header">
      @switch (dialogData.mode) {
        @case ('create') {
          <h1>{{ 'inventory.modalHeaders.createProduct' | translate }}</h1>
        }
        @case ('view') {
          <h1>
            {{ 'inventory.modalHeaders.viewProduct' | translate }}
            {{ inventoryItem().productUpc }}
          </h1>
        }
      }
      <button class="product-info-modal__header-close" (click)="onClose()">
        <app-icon class="product-info-modal__header-cross-icon" [icon]="iconName.CLOSE" />
      </button>
    </div>

    @if (dialogData.mode === 'view') {
      <app-tabs [tabs]="tabs" [(activeTab)]="activeTab" [fullWidth]="true" [centered]="true" />
    }

    @switch (activeTab()) {
      @case ('general') {
        <app-product-general-info
          [item]="inventoryItem()"
          [isEditable]="dialogData.mode !== 'view'"
          [form]="form"
        />
      }
      @case ('product-details') {
        <app-product-details-info [item]="inventoryItem()" />
      }
    }

    @if (!isLoading()) {
      <div class="product-info-modal__footer">
        @switch (dialogData.mode) {
          @case ('view') {
            <button class="product-info-modal__footer--primary-btn close" (click)="onClose()">
              {{ 'inventory.buttons.close' | translate }}
            </button>
          }
          @case ('create') {
            <button class="product-info-modal__footer--secondary-btn" (click)="onClose()">
              {{ 'inventory.buttons.cancel' | translate }}
            </button>
            <button class="product-info-modal__footer--primary-btn add" (click)="onAdd()">
              {{ 'inventory.buttons.add' | translate }}
            </button>
          }
        }
      </div>
    }
  </div>
</div>
